import React, { useState } from "react";
import ErrorComponent from "Common/components/ErrorComponent";
import Footer from "Global/Footer";
import img from 'Common/img/WireframesGlobal Nav Logo.svg';
import TeamPhoenixImage from 'Common/img/PNG/Team_Phoenix.png';
import { appRedirect } from "Global/UserAccessToken";
import { useDocumentTitle } from "Common/hooks/useDocumentTitle";

export const UnAuthorizedCompoent = () =>{
    const [showError, setShowError] = useState(true);
    useDocumentTitle("Next-GenProservice");

    const handleClose = () => {
		setShowError(false);
		appRedirect();
	};
    return (
        <div className="row" style={{ display: "block" }}>
            <div className="lgBorderTop">
                <div className="linearGradientTop"></div>
                <div className="boxShadowTop"></div>
            </div>
            <div className="row">
                <img src={img} className="bec-logo" alt="Beckman Coulter" />
            </div>
            <div className="row teamPhoenixImage">
                <img className='teamPhoenixImage' src={TeamPhoenixImage} />
            </div>
            <ErrorComponent show={showError} heading='REQUEST ACCESS'
                message='You do not have access to the application feature.
                Please contact DxS IntelliServe support team to request access'
                handleClose={handleClose} />
            <div className="lgBorderBottom">
                <div className="linearGradientBottom"></div>
                <div className="boxShadowTop"></div>
            </div>
            <Footer />
        </div>
    )
}